import { create } from "zustand";

import type { Talent } from "@/api/talent/models";
import { formatDateToYearsAndMonths } from "@/utils";
import { zustandHmrFix } from "@/utils/zustand-hmr";

export interface TalentStore {
  talent: Talent | null;
  setTalent: (talent: Talent | null) => void;
}

const initialState: Pick<TalentStore, "talent"> = {
  talent: null,
};

export const useTalentStore = create<TalentStore>((set) => ({
  ...initialState,
  setTalent: (talent) => {
    const imageUrlTalentMain = talent?.photos?.find((photo) => photo.isMain);

    set({
      talent: talent
        ? {
            ...talent,
            talentCode: talent.talentCode ?? "",
            nationality: talent.nationality ?? undefined,
            fullName: talent.fullName ?? "",
            artisticName: talent.artisticName ?? "",
            email: talent.email ?? "",
            age: formatDateToYearsAndMonths(talent.birthday) ?? "",
            picture: {
              url: imageUrlTalentMain?.url ?? "",
            },
          }
        : null,
    });
  },
}));

// Preserva estado durante HMR (Hot Module Reload)
// Solução oficial da comunidade Zustand: https://github.com/pmndrs/zustand/issues/934
if (import.meta.hot) {
  zustandHmrFix("talent-store", useTalentStore);
}
